import React, { useRef } from 'react';

export default function ImageUploader({
  imagePreview,
  onImageChange,
  onRemoveImage,
}) {
  const inputRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    
    reader.onload = (e) => {
      const response ={'media_url': e.target.result, 'media_from':'file_upload', 'name':file.name};
      onImageChange(response, URL.createObjectURL(file));
    };
    reader.readAsDataURL(file);
  };


  return (
    <div>
      <input
        accept="image/*"
        type="file"
        ref={inputRef}
        onChange={(e) => handleImageChange(e)}
        hidden
      />
      <span className="btn-main btn-fullwidth rounded-3" onClick={() => inputRef.current.click()}>
        Nova Foto
      </span>
      {imagePreview && (
        <>
          <br/>
          <img alt="foto" src={imagePreview} style={{ width: '200px', borderRadius: '10px', background: '#dedede', marginTop: '10px' }} />
          <br/><br/>
          <button
            onClick={onRemoveImage}
            className="btn-main btn-fullwidth rounded-3"
            title="Para remover a imagem clique nesse botão e depois em salvar para efetivar a remoção!"
          >
            Remover
          </button>
        </>
      )}
    </div>
  );
}
